import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import { Box, Paper, Skeleton, Stack, Typography } from '@mui/material';
import type { ArchiveStats } from '../api/types';
import { layoutTokens } from '../theme/archiveTheme';

const format = new Intl.NumberFormat('de-DE');

export function StatsStrip({ stats }: { stats: ArchiveStats | null }) {
  const items = stats
    ? [
        { icon: <FolderOutlinedIcon />, value: stats.folders, label: 'Ordner' },
        { icon: <DescriptionOutlinedIcon />, value: stats.pdfs, label: 'PDFs' },
        { icon: <FindInPageOutlinedIcon />, value: stats.searchable, label: 'durchsuchbare Seiten' }
      ]
    : [];

  return (
    <Paper
      variant="outlined"
      sx={{
        display: 'inline-flex',
        px: 1,
        py: 0.75,
        borderRadius: `${layoutTokens.panelRadius}px`,
        backgroundColor: 'background.paper'
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        divider={(
          <Box
            component="span"
            aria-hidden="true"
            sx={{ width: { xs: '100%', sm: '1px' }, height: { xs: '1px', sm: 'auto' }, flexShrink: 0, backgroundColor: 'divider' }}
          />
        )}
      >
        {stats
          ? items.map((item) => (
              <Stack key={item.label} direction="row" spacing={1} alignItems="center" sx={{ px: 1.5, py: 0.5 }}>
                <Box component="span" sx={{ display: 'flex', color: 'primary.main' }}>{item.icon}</Box>
                <Typography variant="body2"><strong>{format.format(item.value)}</strong> {item.label}</Typography>
              </Stack>
            ))
          : <Skeleton width={420} height={34} />}
      </Stack>
    </Paper>
  );
}
